import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ModalComponent} from '@app/shared/components';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Slot} from '@models/slot.model';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-edit-slot-modal',
    templateUrl: './edit-slot-modal.component.html',
    styleUrls: ['./edit-slot-modal.component.scss']
})
export class EditSlotModalComponent {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() dismissible = true;
    @Input() isLoading = false;

    @Output() cancelInfoModal = new EventEmitter<any>();
    @Output() editSlot = new EventEmitter<any>();

    slotForm: UntypedFormGroup;
    showValidations = false;
    selectedSlot;

    constructor(public translateService: TranslateService) {
        this.slotForm = new UntypedFormGroup({
            'name': new UntypedFormControl('')
        });
    }

    open(slot: Slot = null) {
        this.modal.open();
        this.selectedSlot = slot;
        this.slotForm.get('name').setValue(slot ? slot.name : null);
    }

    close() {
        this.slotForm.reset();
        this.modal.close();
    }

    onCancel() {
        this.cancelInfoModal.emit();
    }

    onSaveSlot() {
        if (!this.slotForm.valid) {
            this.showValidations = true;
            return;
        }
        this.showValidations = false;

        const formData = Object.assign({}, this.slotForm.value);
        formData.id = this.selectedSlot ? this.selectedSlot.id : null;

        this.editSlot.emit({
            operation: this.selectedSlot ? 'edit' : 'add',
            data: formData
        });

    }

    get modalTile() {
        return this.selectedSlot ? this.translateService.instant('admin.lifts.slotModal.titleEdit') :
            this.translateService.instant('admin.lifts.slotModal.titleAdd');
    }

}
